import { render, staticRenderFns } from "./PaymentReceipt.vue?vue&type=template&id=3572d916&scoped=true&"
import script from "./PaymentReceipt.vue?vue&type=script&lang=js&"
export * from "./PaymentReceipt.vue?vue&type=script&lang=js&"
import style0 from "./PaymentReceipt.vue?vue&type=style&index=0&id=3572d916&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3572d916",
  null
  
)

export default component.exports